import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function Privacy() {
  const effectiveDate = 'June 1, 2023';
  return <div className="w-full min-h-screen bg-[#1E2A38] text-[#F5F7FA] font-sans" data-id="element-3071">
      <Header data-id="element-3072" />
      <main className="max-w-4xl mx-auto px-6 py-12" data-id="element-3073">
        <h1 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-3074">Privacy & Terms</h1>
        {/* Privacy Policy Section */}
        <section className="mb-16" data-id="element-3075">
          <div className="bg-[#1A2331] rounded-xl p-8" data-id="element-3076">
            <h2 className="text-2xl font-bold mb-4" data-id="element-3077">
              Privacy Policy for Briix
            </h2>
            <p className="text-sm text-[#F5F7FA] text-opacity-70 mb-6" data-id="element-3078">
              Effective Date: {effectiveDate}
            </p>
            <p className="mb-6" data-id="element-3079">
              Briix ("we," "us," or "our") is committed to protecting your
              privacy. This Privacy Policy explains how we collect, use, and
              protect your information when you use our platform, including our
              web app, services, and integrations (collectively, the
              "Services").
            </p>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3080">
              1. Information We Collect
            </h3>
            <h4 className="text-lg font-medium mb-2" data-id="element-3081">
              a. Information You Provide
            </h4>
            <ul className="list-disc pl-6 mb-4 space-y-1 text-[#F5F7FA] text-opacity-90" data-id="element-3082">
              <li data-id="element-3083">
                Account information: Your name, email address, and password.
              </li>
              <li data-id="element-3084">
                Communication data: Feedback, support requests, or inquiries.
              </li>
            </ul>
            <h4 className="text-lg font-medium mb-2" data-id="element-3085">
              b. Information We Collect from Google Services
            </h4>
            <p className="mb-3" data-id="element-3086">
              With your explicit consent, we access the following data via
              Google APIs:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-1 text-[#F5F7FA] text-opacity-90" data-id="element-3087">
              <li data-id="element-3088">
                Gmail metadata (e.g., subject, sender, date) for emails related
                to calendar events.
              </li>
              <li data-id="element-3089">
                Google Calendar events including title, date/time, participants.
              </li>
              <li data-id="element-3090">Basic Google profile information (name, email).</li>
            </ul>
            <p className="mb-4" data-id="element-3091">
              We do not access or store the full content of emails or your
              entire email history.
            </p>
            <h4 className="text-lg font-medium mb-2" data-id="element-3092">
              c. Automatically Collected Data
            </h4>
            <ul className="list-disc pl-6 mb-6 space-y-1 text-[#F5F7FA] text-opacity-90" data-id="element-3093">
              <li data-id="element-3094">Device type, browser, operating system, IP address.</li>
              <li data-id="element-3095">
                Usage data such as logins, clicks, and navigation within our
                platform.
              </li>
            </ul>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3096">
              2. How We Use Your Information
            </h3>
            <ul className="list-disc pl-6 mb-6 space-y-1 text-[#F5F7FA] text-opacity-90" data-id="element-3097">
              <li data-id="element-3098">
                To provide AI-generated meeting briefs and attendee insights.
              </li>
              <li data-id="element-3099">To improve our services and user experience.</li>
              <li data-id="element-3100">
                To communicate with you about updates, support, and important
                notices.
              </li>
            </ul>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3101">
              3. Data Storage & Retention
            </h3>
            <ul className="list-disc pl-6 mb-6 space-y-1 text-[#F5F7FA] text-opacity-90" data-id="element-3102">
              <li data-id="element-3103">
                Temporary metadata and AI-generated summaries are stored for a
                limited time (e.g., 7 days) unless otherwise specified.
              </li>
              <li data-id="element-3104">No full email content is stored.</li>
              <li data-id="element-3105">You may request account and data deletion at any time.</li>
            </ul>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3106">
              4. Data Sharing & Third Parties
            </h3>
            <p className="mb-3" data-id="element-3107">
              We do not share your personal or Google-sourced data with third
              parties except:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-1 text-[#F5F7FA] text-opacity-90" data-id="element-3108">
              <li data-id="element-3109">As required by law.</li>
              <li data-id="element-3110">With your explicit consent.</li>
              <li data-id="element-3111">
                To subprocessors necessary to operate the Services (under strict
                agreements).
              </li>
            </ul>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3112">5. Your Rights</h3>
            <ul className="list-disc pl-6 mb-6 space-y-1 text-[#F5F7FA] text-opacity-90" data-id="element-3113">
              <li data-id="element-3114">
                Revoke Google access at:{' '}
                <a href="https://myaccount.google.com/permissions" className="text-[#C8F169] hover:underline" data-id="element-3115">
                  https://myaccount.google.com/permissions
                </a>
              </li>
              <li data-id="element-3116">Request deletion of your account and data.</li>
              <li data-id="element-3117">
                Contact us at{' '}
                <a href="mailto:support@briix.ai" className="text-[#C8F169] hover:underline" data-id="element-3118">
                  support@briix.ai
                </a>{' '}
                for privacy-related inquiries.
              </li>
            </ul>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3119">6. Security</h3>
            <p className="mb-6" data-id="element-3120">
              We use industry-standard encryption and secure infrastructure to
              protect your data. OAuth tokens are rotated and never stored
              unnecessarily.
            </p>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3121">
              7. Compliance with Google Policies
            </h3>
            <p className="mb-6" data-id="element-3122">
              Briix complies with Google's API Services User Data Policy and
              Limited Use requirements. We do not use your data for advertising
              or unrelated analytics.
            </p>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3123">
              8. Changes to This Policy
            </h3>
            <p className="mb-6" data-id="element-3124">
              We may update this Privacy Policy. When we do, we'll revise the
              effective date and notify users where required.
            </p>
          </div>
        </section>
        {/* Terms and Conditions Section */}
        <section data-id="element-3125">
          <div className="bg-[#1A2331] rounded-xl p-8" data-id="element-3126">
            <h2 className="text-2xl font-bold mb-4" data-id="element-3127">
              Terms and Conditions for Briix
            </h2>
            <p className="text-sm text-[#F5F7FA] text-opacity-70 mb-6" data-id="element-3128">
              Effective Date: {effectiveDate}
            </p>
            <p className="mb-6" data-id="element-3129">
              Welcome to Briix. By accessing or using our Services, you agree to
              be bound by these Terms and Conditions ("Terms").
            </p>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3130">1. Eligibility</h3>
            <p className="mb-6" data-id="element-3131">
              You must be 18 years or older to use Briix. You agree to provide
              accurate account information and keep it up to date.
            </p>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3132">
              2. Use of the Services
            </h3>
            <p className="mb-3" data-id="element-3133">
              You agree to use Briix only for lawful purposes and in compliance
              with Google's terms and all applicable regulations.
            </p>
            <p className="mb-3" data-id="element-3134">You may not:</p>
            <ul className="list-disc pl-6 mb-6 space-y-1 text-[#F5F7FA] text-opacity-90" data-id="element-3135">
              <li data-id="element-3136">Use Briix to gain unauthorized access to email data.</li>
              <li data-id="element-3137">
                Reproduce, duplicate, or exploit the service without permission.
              </li>
              <li data-id="element-3138">Use the platform for harmful or illegal activities.</li>
            </ul>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3139">3. Google API Access</h3>
            <p className="mb-3" data-id="element-3140">
              By connecting your Gmail or Google Calendar account, you consent
              to our access and limited processing of your data as described in
              our Privacy Policy and Consent Agreement.
            </p>
            <p className="mb-3" data-id="element-3141">You retain the right to:</p>
            <ul className="list-disc pl-6 mb-6 space-y-1 text-[#F5F7FA] text-opacity-90" data-id="element-3142">
              <li data-id="element-3143">Revoke access at any time.</li>
              <li data-id="element-3144">Delete your data and account.</li>
            </ul>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3145">
              4. Intellectual Property
            </h3>
            <p className="mb-6" data-id="element-3146">
              All content, branding, and software associated with Briix are the
              property of the company and may not be used without permission.
            </p>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3147">5. Termination</h3>
            <p className="mb-6" data-id="element-3148">
              We may suspend or terminate your access to the Services at our
              discretion, especially if you breach these Terms or misuse the
              platform.
            </p>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3149">6. Disclaimers</h3>
            <p className="mb-6" data-id="element-3150">
              Briix is provided "as-is" without warranties of any kind. We do
              not guarantee uninterrupted service or accuracy of AI-generated
              content.
            </p>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3151">
              7. Limitation of Liability
            </h3>
            <p className="mb-6" data-id="element-3152">
              To the maximum extent permitted by law, Briix is not liable for
              any indirect, incidental, or consequential damages arising from
              your use of the Services.
            </p>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3153">8. Governing Law</h3>
            <p className="mb-6" data-id="element-3154">
              These Terms are governed by the laws of California. Any disputes
              shall be handled in the courts of California.
            </p>
            <h3 className="text-xl font-semibold mb-3" data-id="element-3155">9. Contact Us</h3>
            <p className="mb-6" data-id="element-3156">
              If you have questions about these Terms or the Privacy Policy,
              email us at{' '}
              <a href="mailto:support@briix.ai" className="text-[#C8F169] hover:underline" data-id="element-3157">
                support@briix.ai
              </a>
              .
            </p>
          </div>
        </section>
      </main>
      <Footer data-id="element-3158" />
    </div>;
}